import { procurement as procurementEn } from '../en/procurement';

export const procurement = {
  ...procurementEn,
  payables: 'ගෙවිය යුතු ගිණුම්',
  supplierStatement: 'සැපයුම්කරු ප්‍රකාශනය',
  payablesDescription: "මිලදී ගැනීමේ ඇණවුම්වලින් සැපයුම්කරුවන්ට ගෙවිය යුතු ශේෂ",
  totalOutstanding: "මුළු ගෙවිය යුතු මුදල",
  supplier: "සැපයුම්කරු",
  phone: "දුරකථනය",
  aging0to30: "දින 0-30",
  aging31to60: "දින 31-60",
  aging61to90: "දින 61-90",
  aging90plus: "දින 90+",
  noPayablesFound: "ගෙවිය යුතු ශේෂ නැත",
  noPayablesFoundDescription: "සියලුම සැපයුම්කරු ශේෂ පියවා ඇත",
  failedToLoadPayables: "ගෙවිය යුතු ගිණුම් පූරණය කිරීමට අසමත් විය",
  searchBySupplierName: "සැපයුම්කරුගේ නම හෝ දුරකථන අංකය අනුව සොයන්න",
  openingBalance: "ආරම්භක ශේෂය",
  closingBalance: "අවසාන ශේෂය",
  debit: "හර",
  credit: "බැර",
  date: "දිනය",
  type: "වර්ගය",
  reference: "යොමුව",
  balance: "ශේෂය",
  selectDateRange: "දින පරාසය තෝරන්න",
  noTransactionsFound: "ගනුදෙනු හමු නොවීය",
  noTransactionsFoundDescription: "තෝරාගත් දින පරාසය තුළ ගනුදෙනු නැත",
  failedToLoadSupplierStatement: "සැපයුම්කරු ප්‍රකාශනය පූරණය කිරීමට අසමත් විය",
  transactionType_purchase_order: "මිලදී ගැනීමේ ඇණවුම",
  transactionType_supplier_payment: "ගෙවීම",
  transactionType_debit_note: "ණය සටහන",
  supplierStatementTitle: "සැපයුම්කරු ප්‍රකාශනය",
  thankYouMessage: "ඔබගේ ව්‍යාපාරයට ස්තූතියි!",
  accountStart: "ගිණුම ආරම්භය",
  today: "අද",
  statementPeriod: "කාල සීමාව",
  statementOrderHint: "පැරණිතම පළමුව — ධාවන ශේෂය ඉහළ සිට පහළට කියවන්න",
};
